import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import {
  Field,
  Radio,
  RadioGroup,
  FluentProvider,
  webLightTheme,
  Input,
} from '@fluentui/react-components';
import React from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { IShadowCompany, SHADOW_COMPANY_NAME_SUFFIX } from './types';
import { yesOption, noOption } from '../../../utils/types/CommonDropdownOptions';

interface IShadowCompanyFormProps {
  form: UseFormMethods<IShadowCompany>;
  data: IShadowCompany;
}

const ShadowCompanyForm = ({ form, data }: IShadowCompanyFormProps): JSX.Element => {
  const { control, errors, watch, setValue } = form;

  const isShadowCompanyNeeded = watch(
    'isShadowCompanyNeeded',
    data?.isShadowCompanyNeeded?.toString().toLowerCase(),
  );

  const shadowCompanyNameLength = 25 - SHADOW_COMPANY_NAME_SUFFIX.length;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Controller
          name="isShadowCompanyNeeded"
          defaultValue={
            data?.isShadowCompanyNeeded
              ? data?.isShadowCompanyNeeded?.toString().toLowerCase()
              : 'false'
          }
          control={control}
          render={() => {
            return (
              <Field label="Shadow Company Needed">
                <RadioGroup
                  id="isShadowCompanyNeeded"
                  name="isShadowCompanyNeeded"
                  value={isShadowCompanyNeeded}
                  onChange={(e, radioData): void => {
                    setValue('isShadowCompanyNeeded', radioData.value);
                    if (radioData.value === 'false') {
                      setValue('shadowCompanyName', null);
                    }
                  }}
                >
                  <Radio value={yesOption.key} label={yesOption.text} />
                  <Radio value={noOption.key} label={noOption.text} />
                </RadioGroup>
              </Field>
            );
          }}
        />
        <Controller
          control={control}
          name="name"
          defaultValue={data?.name || ''}
          rules={{
            maxLength: {
              value: shadowCompanyNameLength,
              message: `Shadow Company Name can only be a max of ${shadowCompanyNameLength} characters`,
            },
          }}
          render={({ onChange, onBlur, value, name, ref }) => (
            <Field label="Shadow Company Name" validationMessage={errors?.name?.message}>
              <Input
                id="shadowCompanyName"
                value={value}
                name={name}
                ref={ref}
                onBlur={onBlur}
                onChange={(ev, inputData) => onChange(inputData.value)}
                contentAfter={SHADOW_COMPANY_NAME_SUFFIX}
                disabled={
                  isShadowCompanyNeeded
                    ? isShadowCompanyNeeded.toString().toLowerCase() !== 'true'
                    : true
                }
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default ShadowCompanyForm;
